import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import SidebarBranch from '../../components/SidebarBranch/SidebarBranch';
import { deliveryTypeStore } from '../../store/deliveryTypeStore';
import { branchStore } from 'src/mobx/branchStore';
import { localeStore } from 'src/mobx/localesStore';
import { IBranch } from 'src/types/branches';
import { isBranchAvailableToDelivery } from 'src/utils/helpers';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';
import ScrollableList from 'src/view/components/ScrollableList/ScrollableList';

const SidebarBranchesList: React.FC = observer((): JSX.Element => {
  const [searchValue, setSearchValue] = useState<string>('');

  const handleChangeSearch = useCallback((value: string) => {
    setSearchValue(value);
  }, []);

  const handleFetchBranches = () => {
    branchStore.fetchBranches(deliveryTypeStore.deliveryType, false);
  };

  const renderBranch = (branch: IBranch | undefined, index: number) => {
    return <SidebarBranch key={branch?.id || index} branch={branch} />;
  };

  /**
   * List of branches available to show.
   */
  const branchesList = useMemo(() => {
    return branchStore.pagination.data.filter((branch) => isBranchAvailableToDelivery(branch, deliveryTypeStore.deliveryType, searchValue));
  }, [searchValue, branchStore.pagination.data, deliveryTypeStore.deliveryType]);

  return (
    <div className="d-flex flex-column flex-1">
      {/* search input */}
      <SearchInput
        onChangeText={handleChangeSearch}
        placeholder={localeStore.t('txt_search')}
        withResetIcon
        loading={branchStore.pagination.loading}
        value={searchValue}
        className="mb-2 full-width"
        inputClassName="input input-mini family-medium border-gray text-size-16"
      />
      {/* branches list */}
      <ScrollableList
        renderItem={renderBranch}
        list={branchesList}
        last_page={branchStore.pagination.last_page}
        refreshing={branchStore.pagination.refreshing}
        loading={branchStore.pagination.loading}
        autoFetch
        fetch={handleFetchBranches}
        emptyListText="no_more_branches_found"
        pages={[]}
        scrollToTop={false}
        current_page={branchStore.pagination.current_page}
      />
      {/* submit button */}
      <Button
        title={localeStore.t('select_pickup_branch')}
        onClick={deliveryTypeStore.submit}
        disabled={!deliveryTypeStore.isEditableOrder || !deliveryTypeStore.selectedDeliveryState[deliveryTypeStore.deliveryType].branch}
        loading={branchStore.pagination.loading}
        size="large"
        stretched
      />
    </div>
  );
});

export default SidebarBranchesList;
